import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-error',
  templateUrl: './payment-error.component.html',
  styleUrls: ['./payment-error.component.css']
})
export class PaymentErrorComponent implements OnInit {
  languageCheck: any;

  constructor() { }

  ngOnInit(): void {
    this.languageCheck = localStorage.getItem('language');
    this.notifyFlutterPaymentError();
  }

  private notifyFlutterPaymentError(): void {
    if (typeof window === 'undefined') return;

    window.parent.postMessage(
      {
        type: 'PAYMENT_ERROR',
        url: window.location.href
      },
      '*'
    );
  }
}